/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Ik_Cirkel_Sociaal_EmotioneelInputs */

const nl_rapporten_config_elements_ik_cirkel_sociaal_emotioneel = /** @type {(inputs: Rapporten_Config_Elements_Ik_Cirkel_Sociaal_EmotioneelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik-cirkel (sociaal-emotioneel)`)
};

/**

* @param {Rapporten_Config_Elements_Ik_Cirkel_Sociaal_EmotioneelInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_ik_cirkel_sociaal_emotioneel = /** @type {((inputs?: Rapporten_Config_Elements_Ik_Cirkel_Sociaal_EmotioneelInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Ik_Cirkel_Sociaal_EmotioneelInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_ik_cirkel_sociaal_emotioneel(inputs)
});
export { rapporten_config_elements_ik_cirkel_sociaal_emotioneel as "rapporten.config.elements.ik_cirkel_sociaal_emotioneel" }